import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useEffect, useState } from 'react';
import Modal from 'ud-ui/components/modal';
import { deleteBoard } from 'modules/template-editor/store/templates/actions';
import { resetPressedState } from 'modules/template-editor/store/templates/templates';
import useBoards from 'modules/template-editor/ui/hooks/use-boards';
import { isDuplicateRequest } from 'shared/errors';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';
import { useAppDispatch } from 'store/hooks';

function useDeleteModal() {
  const { t } = useLingui();
  const dispatch = useAppDispatch();
  const toastApiError = useToastApiError();
  const { activeBoard, isFinished, process } = useBoards();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Промис — окну подтверждения: его кнопки заперты до ответа. Закрывает окно эффект ниже по `isFinished`.
  const onSubmit = useCallback(async () => {
    if (!activeBoard) return;
    const arg = { id: activeBoard.id };
    try {
      await dispatch(deleteBoard(arg)).unwrap();
    } catch (error) {
      // Код 15 — повтор: первый запрос табло уже удалил. Стор приводится к тому, что дал бы успех, —
      // табло уходит из списка, а эффект ниже закрывает окно (раньше оно висело над удалённым).
      if (isDuplicateRequest(error)) {
        dispatch(deleteBoard.fulfilled(arg, '', arg));
        return;
      }
      toastApiError(error, msg`Не удалось удалить табло`);
    }
  }, [activeBoard, dispatch, toastApiError]);

  useEffect(() => {
    if (!isFinished) {
      return;
    }
    if (process !== 'delete board') {
      return;
    }
    close();
    dispatch(resetPressedState());
  }, [close, dispatch, isFinished, process]);

  const entityName = activeBoard?.name;

  return {
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={entityName ? t`Удалить табло «${entityName}»?` : t`Удалить табло?`}
        description={t`Это действие необратимо.`}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
    close,
    open,
  };
}

export default useDeleteModal;
